/** relationship_source enum → operator-readable badge (UX B2). Tokens seen in
 *  prod: gis_attribute / gis_import (the import truth), spatial_linking (the
 *  token scripts/spatial_linking.py writes) plus the legacy spatial_analysis,
 *  and manual_assignment. Unknown tokens render de-snake_cased with the raw
 *  value in the tooltip — never a bare enum. */
const SOURCE_CONFIG: Record<string, { label: string; title: string; color: string }> = {
  gis_attribute: { label: 'GIS', title: 'From the GIS record', color: 'bg-blue-100 text-blue-700' },
  gis_import: { label: 'GIS', title: 'From the GIS record', color: 'bg-blue-100 text-blue-700' },
  spatial_analysis: { label: 'Map position', title: 'Located by map position', color: 'bg-indigo-100 text-indigo-700' },
  spatial_linking: { label: 'Map position', title: 'Located by map position', color: 'bg-indigo-100 text-indigo-700' },
  manual_assignment: { label: 'Manual', title: 'Assigned by a person', color: 'bg-amber-100 text-amber-700' },
}

interface RelationshipBadgeProps {
  source: string | null | undefined
}

export function RelationshipBadge({ source }: RelationshipBadgeProps) {
  if (!source) return null
  const config = SOURCE_CONFIG[source] ?? {
    label: source.replace(/_/g, ' '),
    title: `Link source: ${source}`,
    color: 'bg-gray-100 text-gray-600',
  }
  return (
    <span
      title={config.title}
      className={`inline-block px-1.5 py-0.5 rounded text-[10px] font-medium ${config.color}`}
    >
      {config.label}
    </span>
  )
}
